import { BrowserRouter, Routes, Route } from "react-router-dom";
import { lazy, Suspense, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Cursor from "./components/Cursor";
const About = lazy(() => import("./components/About"));
const Education = lazy(() => import("./components/Education"));
const Projects = lazy(() => import("./components/Projects"));
const Skills = lazy(() => import("./components/Skills"));
const CompetitiveProgramming = lazy(() => import("./components/CompetitiveProgramming"));
const Contact = lazy(() => import("./components/Contact"));
const Footer = lazy(() => import("./components/Footer"));
const Chatbot = lazy(() => import("./components/Chatbot"));
const Agent = lazy(() => import("./components/Agent"));
const Blog = lazy(() => import("./components/Blogs"));
function Portfolio() {
  const [viewMode, setViewMode] = useState("Space");
  if (viewMode === "Agent") {
    return (
      <Suspense fallback={null}>
        <Agent onBack={() => setViewMode("Space")} />
      </Suspense>
    );
  }
  return (
    <div className="bg-gray-50 text-gray-900 font-sans overflow-x-hidden">
      <Cursor />
      <Navbar viewMode={viewMode} onViewChange={setViewMode} />
      <Hero />
      <Suspense fallback={null}>
        <About />
        <Education />
        <Projects />
        <Skills />
        <CompetitiveProgramming />
        <Contact />
        <Footer />
        <Chatbot />
      </Suspense>
    </div>
  );
}
export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="/blog" element={
          <Suspense fallback={null}>
            <Blog />
          </Suspense>
        } />
      </Routes>
    </BrowserRouter>
  );
}
